// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mo-date-field[data-v-da0bbec6] {
  margin: 0 1px;
  min-width: 0;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
}
.mo-date-field[data-v-da0bbec6]:first-of-type {
  margin-left: 0;
}
.mo-date-field[data-v-da0bbec6]:last-of-type {
  flex-grow: 3;
  flex-shrink: 3;
  margin-right: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
